import { useEffect } from 'react'
import { FieldValues, FormState } from 'react-hook-form'

export const useFormDirty = (
  onFormDirty: (_: boolean) => void,
  formState: FormState<FieldValues> | FormState<FieldValues>[]
) => {
  const dirtyFieldsCount = Array.isArray(formState)
    ? formState.some(state => Object.keys(state.dirtyFields).length > 0)
    : Object.keys(formState.dirtyFields).length > 0

  useEffect(() => {
    onFormDirty(dirtyFieldsCount)
  }, [dirtyFieldsCount, onFormDirty])
}
